import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../features/ui"
import { BookmarkButton } from "../../../../features/bookmarks"
import { RoutePath } from "../../../../features/routes"
import { useManagerState } from "../../../manager"
import { define } from "../../../../utils/typeUtils"
import { StockList } from "./stockList"
import { Stock } from "../../state/types"
import { useStockLoaders } from "../../loaders/stockLoaders"
import { Product, useProductLoaders } from "../../../products"

export const StockListLoader = () => {
    const { currentBranch } = useManagerState()
    const branchId = define(currentBranch).id

    const [stocks, setStocks] = useState<Stock[]>([])
    const [products, setProducts] = useState<Product[]>([])
    const [ready, setReady] = useState(false)

    const stockLoaders = useStockLoaders()
    const productLoaders = useProductLoaders()

    const populate = async () => {
        const { loadBranchStocks } = stockLoaders()
        const branchStocks = await loadBranchStocks(branchId)
        setStocks(branchStocks)
        const productIds = branchStocks.map(stock => stock.productId)
        const loadedProducts = await productLoaders().loadProducts(productIds)
        setProducts(loadedProducts)
    }

    useEffect(() => {
        setReady(false)
        populate().then(() => setReady(true))
    }, [branchId])

    return (
        <PanelLoader
            title="Stock"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.STOCK} />}
        >
            <StockList
                stocks={stocks}
                products={products}
            />
        </PanelLoader>
    )
}
